import { useLanguage } from '../contexts/LanguageContext';
import en from './en.json';
import heb from './heb.json';

const translations = {
    en,
    heb
};

const getNestedObject = (nestedObj, pathArr) => {
    return pathArr.reduce((obj, key) => 
        (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj
    );
}

function Trans({ k, params }) {
    const { language } = useLanguage();
    const rawTranslation = getNestedObject(translations[language], k.split('.')) || k;
    const translation = Object.keys(params || {}).reduce((acc, paramKey) => {
        return acc.replace(`{${paramKey}}`, params[paramKey]);
    }, rawTranslation);

    return <>{translation}</>;
}

export default Trans;
